module.exports = __webpack_public_path__ + "static/media/kids_25.a514a698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_25.jpg
// module id = 5881
// module chunks = 0